import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2494d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"text-align":"center","margin-top":"3rem","margin-bottom":"3rem"} }, "技术产品", -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 产品简介", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 产品定价", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 一句话识别", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 一句话流识别", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 文档下载", -1))
const _hoisted_8 = {
  class: "content",
  style: {"margin-left":"2rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_document = _resolveComponent("document")!
  const _component_setting = _resolveComponent("setting")!
  const _component_Download = _resolveComponent("Download")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "default-active": _ctx.onRoutes,
                class: "el-menu-vertical-demo",
                router: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/specs/product-intro" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_icon_menu)
                        ]),
                        _: 1
                      }),
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/specs/product-price" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_document)
                        ]),
                        _: 1
                      }),
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/specs/asr" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_setting)
                        ]),
                        _: 1
                      }),
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/specs/asr2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_setting)
                        ]),
                        _: 1
                      }),
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/specs/docsDownload" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Download)
                        ]),
                        _: 1
                      }),
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 19 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({ Component }) => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}